import React from 'react';
import { compose } from 'recompose';
import { withStyles } from '@material-ui/core/styles';
import CheckOkButton from './CheckOkButton';
import CheckNoneButton from './CheckNoneButton';

const styles = {
  leftIcon: {
    padding: '0px 5px'
  }
};

const enhance = compose();

const button = enhance(
  ({
    handeOpenSettingGochiKidReceiptModal,
    checked,
    groupId,
    groupGochiKidReceipt
  }) => {
    return (
      <div>
        {checked ? (
          <CheckOkButton
            onClickAction={() => {
              handeOpenSettingGochiKidReceiptModal(true);
            }}
            disabled={groupId && groupGochiKidReceipt === 1}
          />
        ) : (
          <CheckNoneButton
            onClickAction={() => {
              handeOpenSettingGochiKidReceiptModal(true);
            }}
          />
        )}
      </div>
    );
  }
);

export default withStyles(styles)(button);
